import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { fetchPickupPoints } from "../../lib/api";

export const PickupChooser = ({ value, onChange }) => {
  const [points, setPoints] = useState(null);
  useEffect(() => { fetchPickupPoints().then(setPoints).catch(() => {}); }, []);
  const toggle = (id) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  return (
    <div data-testid="extract-pickup-chooser" className="md:col-span-2 border border-[#D1CFC7] p-3">
      <p className="flex items-center gap-2 text-xs font-body text-[#4A4A4A] mb-2"><MapPin size={13} className="text-[#9E4735]" /> Librairies et relais Pick & Read où ce livre est disponible</p>
      {points === null ? <p className="text-[11px] font-body text-[#757575]">Chargement…</p> : points.length === 0 ? <p className="text-[11px] font-body text-[#757575]">Aucune librairie enregistrée (onglet Commandes › Librairies de retrait).</p> : (
        <div className="flex flex-wrap gap-x-5 gap-y-2">
          {points.map((p) => (
            <label key={p.id} className="flex items-center gap-2 text-sm font-body">
              <input type="checkbox" checked={value.includes(p.id)} onChange={() => toggle(p.id)} data-testid={`extract-pickup-${p.id}`} /> {p.name} <span className="text-[#757575] text-xs">({p.city}{p.kind === "pick_read" ? " · Pick & Read" : ""})</span>
            </label>
          ))}
        </div>
      )}
      <p className="text-[11px] font-body text-[#757575] mt-2">{value.length ? `${value.length} point(s) de retrait affiché(s) au lecteur pour ce livre.` : "Aucun coché : aucun point de retrait affiché (le lecteur indique sa ville sur WhatsApp)."}</p>
    </div>
  );
};
